import StableContent from 'components/StableContent'

const Staking = () => {
    return <StableContent />
}

export default Staking
